import { useFabricContext } from '@idmc-ms-fabric/integration';
import { initializeRegistry } from '@infa-hawk/services';
import { ServicesContext } from '@infa-service/core';
import { FC, useEffect } from 'react';

import { useLoginContext } from '../../context/business/InfaLogin/InfaLoginContext';

const InitializeServices: FC = ({ children }) => {
	const { bootoutput } = useLoginContext();
	const { extensionSettings } = useFabricContext();

	useEffect(() => {
		initializeRegistry({ ...bootoutput, extensionSettings });
	}, []);

	return (
		<ServicesContext fetchApi={bootoutput.fetchApi} serviceBaseURLs={bootoutput.serviceBaseURLs}>
			{children}
		</ServicesContext>
	);
};

export default InitializeServices;
